/**
 * Formatter for DataTable cell values.
 *
 * Extracted into a standalone module (no transitive imports of @json-render)
 * so it's testable under CRA's jest, which can't resolve that package's
 * subpath exports (see scripts/fuzz_genui/fuzz-generative-ui.md §Known gaps).
 *
 * `String(obj)` produces the literal text "[object Object]" which is useless
 * to readers and also trips the fuzz harness nan_leak detector. Non-primitive
 * values stringify to JSON instead so a nested row like
 * `{price: {value, currency}}` renders as `{"value":74.9,...}`.
 */
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';

export const formatCellValue = (value: unknown): string => {
  if (isNil(value)) return '';
  if (isObject(value)) {
    try {
      return JSON.stringify(value);
    } catch {
      // Circular refs or BigInt — fall through to a sentinel that's still not
      // the useless "[object Object]" text.
      return '[unprintable value]';
    }
  }
  return String(value);
};
